import { when } from 'mobx';
import { inject } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { FRESHDESK, MainPageNavigatorConstants as ui } from '../../Config/UIConstants';
import { Routes } from '../../_controllers/RouteController';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { DropDownArrow } from '../../images/images';
import { colors } from '../../styles/colors';

import classNames from 'classnames';

import './MainPageWithNavigator.css';

interface IProps {
    store?: ApplicationStore;
}

@inject('store')
export class AccountSettingsDropdown extends React.Component<RouteComponentProps<any> & IProps> {
    private logout = (): void => {
        when(
            () => !!this.props.store && this.props.store.storeIsReady,
            () => {
                this.props.store!.authorizationStore.logout();
            }
        );
    }

    public render() {
        return (
            <div className="mainNavDropdown">
                <a style={styles.accountButton} onClick={() => this.props.history.push(Routes.PROFILE_SETTINGS)}>
                    <p style={styles.accountText}>{ui.ACCOUNT_SETTINGS}</p>
                </a>

                <a style={styles.logoutButton} onClick={() => this.logout()}>
                    <p style={styles.logoutText}>{ui.LOGOUT}</p>
                </a>
            </div>
        );
    }
}

interface ISupportDropdownProps {
    store?: ApplicationStore;
    hideLearningCenter?: any;
    showItem?: any;
    isInLearningCenter?: boolean;
}

interface ISupportDropdownState {
    showLearningCenterItems: boolean;
}

@inject('store')
export class SupportDropdown extends React.Component<ISupportDropdownProps> {

    public state: ISupportDropdownState = {
        showLearningCenterItems: false,
    };

    public render() {
        let learningCenterClass = classNames({
            learningCenterItems: true,
            showItems: this.state.showLearningCenterItems || this.props.isInLearningCenter,
            isInLearningCenter: this.props.isInLearningCenter,
        });

        let dropdownIndicatorClass = classNames({
            dropdown__link__indicator: true,
            active: this.state.showLearningCenterItems || this.props.isInLearningCenter,
        });
        return (
            <div className="supportDropdown mainNavDropdown" style={{
                right: this.props.isInLearningCenter ? -2 : 155,
                top: this.props.isInLearningCenter ? 44 : 78
            }}>

                {this.props.store!.learningCenterStore &&
                <div className="dropdown__item">
                    {!this.props.isInLearningCenter &&
                    <button onClick={
                        () => this.setState({showLearningCenterItems: !this.state.showLearningCenterItems})
                    }
                       className="dropdown__link">
                        Learning Center
                        <img src={DropDownArrow} className={dropdownIndicatorClass}  />
                    </button>
                    }
                    <div className={learningCenterClass} >
                        {this.props.store!.learningCenterStore.items.map((item: any, imgIndex: number) => (
                            <div className="learningCenterItem" key={item.id}
                                 onClick={() => this.props.showItem(item.id)}
                            >
                                <span className="learningCenterItem__itemTitle">{item.title}</span> {item.duration &&  <span className="learningCenterItem__time">&nbsp;-&nbsp;{item.duration}</span>}
                            </div>
                        ))}
                    </div>
                    {/*}*/}
                </div>
                }

                {!this.props.isInLearningCenter &&
                <div className="dropdown__item">
                    <a className="dropdown__link" href={FRESHDESK.NEW_TICKETS} target="_blank">
                        Contact Support
                    </a>
                </div>
                }


                {!this.props.isInLearningCenter &&
                <div className="dropdown__item">
                    <a className="dropdown__link" href={FRESHDESK.FAQS} target="_blank">
                        FAQ
                    </a>
                </div>
                }
            </div>
        );
    }
}

const styles = {
    container: {
        position: 'absolute',
        top: 73,
        right: 30,
        zIndex: 999,
        padding: 0,
        boxShadow: '0px 15px 30px 0 rgba(21,0,49,0.075)',
        overflow: 'hidden'
    } as React.CSSProperties,
    accountButton: {
        height: 45,
        backgroundColor: 'white',
        marginTop: -1,
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 5,
        cursor: 'pointer',
        color: colors.DARK_BACKGROUND
    } as React.CSSProperties,
    image: {
        width: 365,
        objectFit: 'fill',
        marginLeft: -145
    } as React.CSSProperties,
    logoutButton: {
        height: 45,
        backgroundColor: 'white',
        marginTop: -1,
        display: 'flex',
        alignItems: 'center',
        paddingLeft: 20,
        paddingBottom: 5,
        cursor: 'pointer'
    } as React.CSSProperties,
    logoutText: {
        fontSize: 18,
        color: colors.CANCEL_TEXT
    },
    accountText: {
        fontSize: 18
    }
};



// WEBPACK FOOTER //
// ./src/SharedComponents/MainPageWithNavigator/AccountSettingsDropdown.tsx